"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["AddressArea"] = "AddressArea";
  TranslationKey["AddressArea_Placeholder"] = "AddressArea_Placeholder";
  TranslationKey["AddressArea_Tooltip"] = "AddressArea_Tooltip";
  TranslationKey["AddressCity"] = "AddressCity";
  TranslationKey["AddressCity_Placeholder"] = "AddressCity_Placeholder";
  TranslationKey["AddressCity_Tooltip"] = "AddressCity_Tooltip";
  TranslationKey["AddressCountry"] = "AddressCountry";
  TranslationKey["AddressCountry_Placeholder"] = "AddressCountry_Placeholder";
  TranslationKey["AddressDelivery"] = "AddressDelivery";
  TranslationKey["AddressDelivery2"] = "AddressDelivery2";
  TranslationKey["AddressDelivery2_Placeholder"] = "AddressDelivery2_Placeholder";
  TranslationKey["AddressDelivery2_Tooltip"] = "AddressDelivery2_Tooltip";
  TranslationKey["AddressDelivery3"] = "AddressDelivery3";
  TranslationKey["AddressDelivery3_Placeholder"] = "AddressDelivery3_Placeholder";
  TranslationKey["AddressDelivery3_Tooltip"] = "AddressDelivery3_Tooltip";
  TranslationKey["AddressDelivery_Placeholder"] = "AddressDelivery_Placeholder";
  TranslationKey["AddressDelivery_Tooltip"] = "AddressDelivery_Tooltip";
  TranslationKey["AddressDistrict"] = "AddressDistrict";
  TranslationKey["AddressDistrict_Placeholder"] = "AddressDistrict_Placeholder";
  TranslationKey["AddressDistrict_Tooltip"] = "AddressDistrict_Tooltip";
  TranslationKey["AddressLocality"] = "AddressLocality";
  TranslationKey["AddressLocality_Placeholder"] = "AddressLocality_Placeholder";
  TranslationKey["AddressLocality_Tooltip"] = "AddressLocality_Tooltip";
  TranslationKey["AddressProvince"] = "AddressProvince";
  TranslationKey["AddressProvince_Placeholder"] = "AddressProvince_Placeholder";
  TranslationKey["AddressProvince_Tooltip"] = "AddressProvince_Tooltip";
  TranslationKey["AddressRegion"] = "AddressRegion";
  TranslationKey["AddressRegion_Placeholder"] = "AddressRegion_Placeholder";
  TranslationKey["AddressRegion_Tooltip"] = "AddressRegion_Tooltip";
  TranslationKey["AddressSearchTooltip"] = "AddressSearchTooltip";
  TranslationKey["AddressStreetAddress"] = "AddressStreetAddress";
  TranslationKey["AddressStreetAddressTooltip"] = "AddressStreetAddressTooltip";
  TranslationKey["AddressStreetAddress_Placeholder"] = "AddressStreetAddress_Placeholder";
  TranslationKey["AddressTitle"] = "AddressTitle";
  TranslationKey["AddressZipcode"] = "AddressZipcode";
  TranslationKey["AddressZipcode_Placeholder"] = "AddressZipcode_Placeholder";
  TranslationKey["AddressZipcode_Tooltip"] = "AddressZipcode_Tooltip";
  TranslationKey["Address_SearchedAddress"] = "Address_SearchedAddress";
  TranslationKey["Benefits_Header_Title"] = "Benefits_Header_Title";
  TranslationKey["Benefits_ShowLess"] = "Benefits_ShowLess";
  TranslationKey["Benefits_ShowMore"] = "Benefits_ShowMore";
  TranslationKey["Benefits_Text1"] = "Benefits_Text1";
  TranslationKey["Benefits_Text2"] = "Benefits_Text2";
  TranslationKey["Benefits_Text3"] = "Benefits_Text3";
  TranslationKey["Benefits_Title1"] = "Benefits_Title1";
  TranslationKey["Benefits_Title2"] = "Benefits_Title2";
  TranslationKey["Benefits_Title3"] = "Benefits_Title3";
  TranslationKey["Custom_text"] = "Custom_text";
  TranslationKey["EmailVerification_Header"] = "EmailVerification_Header";
  TranslationKey["EmailVerification_Text"] = "EmailVerification_Text";
  TranslationKey["General_Already_Registered"] = "General_Already_Registered";
  TranslationKey["General_header"] = "General_header";
  TranslationKey["Legal_Approval_BlockGuaranteeOrdering"] = "Legal_Approval_BlockGuaranteeOrdering";
  TranslationKey["Legal_Approval_Contact"] = "Legal_Approval_Contact";
  TranslationKey["Legal_Approval_MarketingConsultant"] = "Legal_Approval_MarketingConsultant";
  TranslationKey["Legal_Approval_MarketingExternal"] = "Legal_Approval_MarketingExternal";
  TranslationKey["Legal_Approval_MarketingOriflame"] = "Legal_Approval_MarketingOriflame";
  TranslationKey["Legal_Approval_Newletters"] = "Legal_Approval_Newletters";
  TranslationKey["Legal_Approval_PersonalData"] = "Legal_Approval_PersonalData";
  TranslationKey["Legal_Approval_Publication"] = "Legal_Approval_Publication";
  TranslationKey["Legal_Approval_UplineLeaderBrowse"] = "Legal_Approval_UplineLeaderBrowse";
  TranslationKey["Legal_Approval_UplineLeaderData"] = "Legal_Approval_UplineLeaderData";
  TranslationKey["Legal_Approval_optedOutOfSponsorSelect"] = "Legal_Approval_optedOutOfSponsorSelect";
  TranslationKey["Legal_Approval_orderHistory"] = "Legal_Approval_orderHistory";
  TranslationKey["Legal_Confiramtion2"] = "Legal_Confiramtion2";
  TranslationKey["Legal_Confirmation1"] = "Legal_Confirmation1";
  TranslationKey["Legal_PrivacyPolicy"] = "Legal_PrivacyPolicy";
  TranslationKey["Legal_PrivacyPolicy_Label"] = "Legal_PrivacyPolicy_Label";
  TranslationKey["Legal_Reseller"] = "Legal_Reseller";
  TranslationKey["Legal_ShowLess"] = "Legal_ShowLess";
  TranslationKey["Legal_ShowMore"] = "Legal_ShowMore";
  TranslationKey["Legal_TermsAndConditions"] = "Legal_TermsAndConditions";
  TranslationKey["Legal_TermsAndConditions_Label"] = "Legal_TermsAndConditions_Label";
  TranslationKey["Legal_Text"] = "Legal_Text";
  TranslationKey["ParentalConsentCheckboxLabel"] = "ParentalConsentCheckboxLabel";
  TranslationKey["ParentalConsentDescription"] = "ParentalConsentDescription";
  TranslationKey["ParentalConsentEmail"] = "ParentalConsentEmail";
  TranslationKey["ParentalConsentEmailPlaceholder"] = "ParentalConsentEmailPlaceholder";
  TranslationKey["ParentalConsentEmailTooltip"] = "ParentalConsentEmailTooltip";
  TranslationKey["ParentalConsentPendingExplore"] = "ParentalConsentPendingExplore";
  TranslationKey["ParentalConsentPendingPageDescription"] = "ParentalConsentPendingPageDescription";
  TranslationKey["ParentalConsentPendingPageTitle"] = "ParentalConsentPendingPageTitle";
  TranslationKey["ParentalConsentPhone"] = "ParentalConsentPhone";
  TranslationKey["ParentalConsentPhoneWithPrefix"] = "ParentalConsentPhoneWithPrefix";
  TranslationKey["ParentalConsentPlaceholderPhone"] = "ParentalConsentPlaceholderPhone";
  TranslationKey["ParentalConsentPlaceholderPhonePrefix"] = "ParentalConsentPlaceholderPhonePrefix";
  TranslationKey["ParentalConsentSameEmailValidation"] = "ParentalConsentSameEmailValidation";
  TranslationKey["ParentalConsentSamePhoneValidation"] = "ParentalConsentSamePhoneValidation";
  TranslationKey["ParentalConsentTitle"] = "ParentalConsentTitle";
  TranslationKey["ParentalConsentTooltipPhone"] = "ParentalConsentTooltipPhone";
  TranslationKey["ParentalConsentTooltipPhoneWithPrefix"] = "ParentalConsentTooltipPhoneWithPrefix";
  TranslationKey["PersonalDetails_Button_Continue"] = "PersonalDetails_Button_Continue";
  TranslationKey["PersonalDetails_DateOfBirth"] = "PersonalDetails_DateOfBirth";
  TranslationKey["PersonalDetails_Email"] = "PersonalDetails_Email";
  TranslationKey["PersonalDetails_EmailPlaceholder"] = "PersonalDetails_EmailPlaceholder";
  TranslationKey["PersonalDetails_Email_Tooltip"] = "PersonalDetails_Email_Tooltip";
  TranslationKey["PersonalDetails_FirstName"] = "PersonalDetails_FirstName";
  TranslationKey["PersonalDetails_Gender"] = "PersonalDetails_Gender";
  TranslationKey["PersonalDetails_Gender_Placeholder"] = "PersonalDetails_Gender_Placeholder";
  TranslationKey["PersonalDetails_InvitationCodeNotFound"] = "PersonalDetails_InvitationCodeNotFound";
  TranslationKey["PersonalDetails_Invite_Code"] = "PersonalDetails_Invite_Code";
  TranslationKey["PersonalDetails_Invite_Code_Helper_Text"] = "PersonalDetails_Invite_Code_Helper_Text";
  TranslationKey["PersonalDetails_LastName"] = "PersonalDetails_LastName";
  TranslationKey["PersonalDetails_Passport"] = "PersonalDetails_Passport";
  TranslationKey["PersonalDetails_Password"] = "PersonalDetails_Password";
  TranslationKey["PersonalDetails_Phone"] = "PersonalDetails_Phone";
  TranslationKey["PersonalDetails_PhonePlaceholder"] = "PersonalDetails_PhonePlaceholder";
  TranslationKey["PersonalDetails_PhoneWithPrefix"] = "PersonalDetails_PhoneWithPrefix";
  TranslationKey["PersonalDetails_PlaceholderPhoneWithPrefix"] = "PersonalDetails_PlaceholderPhoneWithPrefix";
  TranslationKey["PersonalDetails_Sponsor"] = "PersonalDetails_Sponsor";
  TranslationKey["PersonalDetails_SponsorTitle"] = "PersonalDetails_SponsorTitle";
  TranslationKey["PersonalDetails_Sponsor_Tooltip"] = "PersonalDetails_Sponsor_Tooltip";
  TranslationKey["PersonalDetails_TaxCode"] = "PersonalDetails_TaxCode";
  TranslationKey["PersonalDetails_TaxCode2"] = "PersonalDetails_TaxCode2";
  TranslationKey["PersonalDetails_TooltipPhone"] = "PersonalDetails_TooltipPhone";
  TranslationKey["PersonalDetails_TooltipPhoneWithPrefix"] = "PersonalDetails_TooltipPhoneWithPrefix";
  TranslationKey["PersonalDetails_UniqueId"] = "PersonalDetails_UniqueId";
  TranslationKey["PersonalDetails_UniqueId_Tooltip"] = "PersonalDetails_UniqueId_Tooltip";
  TranslationKey["PersonalDetails_YourSponsor"] = "PersonalDetails_YourSponsor";
  TranslationKey["PhoneVerification_Continue"] = "PhoneVerification_Continue";
  TranslationKey["PhoneVerification_Header"] = "PhoneVerification_Header";
  TranslationKey["PhoneVerification_NoCode"] = "PhoneVerification_NoCode";
  TranslationKey["PhoneVerification_SendAgain"] = "PhoneVerification_SendAgain";
  TranslationKey["PhoneVerification_Text"] = "PhoneVerification_Text";
  TranslationKey["PhoneVerification_Verified"] = "PhoneVerification_Verified";
  TranslationKey["PhoneVerification_WrongCode"] = "PhoneVerification_WrongCode";
  TranslationKey["addressResults"] = "addressResults";
  TranslationKey["addressSearchValidation"] = "addressSearchValidation";
  TranslationKey["birthDate_DoesntMatchUniqueId"] = "birthDate_DoesntMatchUniqueId";
  TranslationKey["birthDate_LegalRequirementsFailed"] = "birthDate_LegalRequirementsFailed";
  TranslationKey["birthDate_OutOfRange"] = "birthDate_OutOfRange";
  TranslationKey["cannotCreate"] = "cannotCreate";
  TranslationKey["cannotDelete"] = "cannotDelete";
  TranslationKey["cannotGetData"] = "cannotGetData";
  TranslationKey["cannotResend"] = "cannotResend";
  TranslationKey["cannotUpdate"] = "cannotUpdate";
  TranslationKey["cannotVerify"] = "cannotVerify";
  TranslationKey["customerServiceLinkLabel"] = "customerServiceLinkLabel";
  TranslationKey["customer_NotEligible"] = "customer_NotEligible";
  TranslationKey["customer_NotUnique"] = "customer_NotUnique";
  TranslationKey["document_ExpirationTooSoon"] = "document_ExpirationTooSoon";
  TranslationKey["errorOccured"] = "errorOccured";
  TranslationKey["fileTypeIsNotSupported"] = "fileTypeIsNotSupported";
  TranslationKey["genderLabelMan"] = "genderLabelMan";
  TranslationKey["genderLabelOther"] = "genderLabelOther";
  TranslationKey["genderLabelWoman"] = "genderLabelWoman";
  TranslationKey["hide"] = "hide";
  TranslationKey["loginLinkLabel"] = "loginLinkLabel";
  TranslationKey["noSuggestions"] = "noSuggestions";
  TranslationKey["passwordRequirementCharactersCount"] = "passwordRequirementCharactersCount";
  TranslationKey["passwordRequirementDigit"] = "passwordRequirementDigit";
  TranslationKey["passwordRequirementLetter"] = "passwordRequirementLetter";
  TranslationKey["passwordRequirementLowerCaseLetter"] = "passwordRequirementLowerCaseLetter";
  TranslationKey["passwordRequirementSpecialCharacter"] = "passwordRequirementSpecialCharacter";
  TranslationKey["passwordRequirementUpperCaseLetter"] = "passwordRequirementUpperCaseLetter";
  TranslationKey["readMore"] = "readMore";
  TranslationKey["resendInMinute"] = "resendInMinute";
  TranslationKey["searchForAnAddress"] = "searchForAnAddress";
  TranslationKey["successResend"] = "successResend";
  TranslationKey["termsAndConditions_Mandatory"] = "termsAndConditions_Mandatory";
  TranslationKey["validationBirthDateRegex"] = "validationBirthDateRegex";
  TranslationKey["validationDateRegex"] = "validationDateRegex";
  TranslationKey["validationEmailIsAlreadyUsed"] = "validationEmailIsAlreadyUsed";
  TranslationKey["validationEmailTerminatedCustomer"] = "validationEmailTerminatedCustomer";
  TranslationKey["validationLength"] = "validationLength";
  TranslationKey["validationMandatoryPropertyIsNull"] = "validationMandatoryPropertyIsNull";
  TranslationKey["validationMaxLength"] = "validationMaxLength";
  TranslationKey["validationMaxValue"] = "validationMaxValue";
  TranslationKey["validationMinLength"] = "validationMinLength";
  TranslationKey["validationMinValue"] = "validationMinValue";
  TranslationKey["validationRegex"] = "validationRegex";
  TranslationKey["validationRegexBirthDate"] = "validationRegexBirthDate";
  TranslationKey["validationRegexEmail"] = "validationRegexEmail";
  TranslationKey["validationRegexIdentityCardDateExpiration"] = "validationRegexIdentityCardDateExpiration";
  TranslationKey["validationRegexPhone"] = "validationRegexPhone";
  TranslationKey["validationRegexUniqueID"] = "validationRegexUniqueID";
  TranslationKey["validationRequired"] = "validationRequired";
  TranslationKey["validationUniqueAlias"] = "validationUniqueAlias";
  TranslationKey["validationUniqueBankAccount"] = "validationUniqueBankAccount";
  TranslationKey["validationUniqueCustomerAttribute"] = "validationUniqueCustomerAttribute";
  TranslationKey["validationUniqueDisplayName"] = "validationUniqueDisplayName";
  TranslationKey["validationUniquePhone"] = "validationUniquePhone";
  TranslationKey["validationUniqueTaxCode"] = "validationUniqueTaxCode";
  TranslationKey["validationUniqueTaxCode2"] = "validationUniqueTaxCode2";
  TranslationKey["validationUniqueUniqueId"] = "validationUniqueUniqueId";
  TranslationKey["validationValidConfirmationCode"] = "validationValidConfirmationCode";
  TranslationKey["validationValidOldPassword"] = "validationValidOldPassword";
  TranslationKey["validationValidPhone"] = "validationValidPhone";
  TranslationKey["validationValidSponsorNumber"] = "validationValidSponsorNumber";
  TranslationKey["validationValidUniqueId"] = "validationValidUniqueId";
  TranslationKey["validationXmlCharacters"] = "validationXmlCharacters";
  return TranslationKey;
}({});
//# sourceMappingURL=TranslationKey.js.map